export default __webpack_public_path__ + "static/media/san-rafael-11.5094ddbe.jpg";